<template>
  <v-container class="my-5">
    <v-dialog v-model="dialogFineDetail" scrollable max-width="700">
      <v-card class="elevation-5">
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            Detalles de la Multa
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
              class="align-self-end"
              color="red"
              icon
              @click="dialogFineDetail = false"
          ><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout row wrap v-if="selectedFine">
            <v-flex xs12 md6>
              <div class="mb-4">
                <h3 class="primary--text mb-3">Datos del Vehículo</h3>
                <p><strong>Placa:</strong> {{ selectedFine.plate }}</p>
                <p><strong>Modelo:</strong> {{ selectedFine.vehicle_model }}</p>
                <p><strong>Color:</strong> {{ selectedFine.vehicle_color }}</p>
                <p><strong>Año:</strong> {{ selectedFine.vehicle_year }}</p>
              </div>
            </v-flex>
            <v-flex xs12 md6>
              <div class="mb-4">
                <h3 class="primary--text mb-3">Infracción</h3>
                <p><strong>Velocidad Detectada:</strong> <span class="red--text font-weight-bold">{{ selectedFine.speed_detected }} km/h</span></p>
                <p><strong>Velocidad Permitida:</strong> {{ selectedFine.speed_limit }} km/h</p>
                <p><strong>Exceso:</strong> <span class="red--text font-weight-bold">{{ selectedFine.speed_detected - selectedFine.speed_limit }} km/h</span></p>
                <p><strong>Fecha y Hora:</strong> {{ selectedFine.detection_datetime }}</p>
              </div>
            </v-flex>
            <v-flex xs12 md6>
              <div class="mb-4">
                <h3 class="primary--text mb-3">Datos del Residente</h3>
                <p><strong>Propietario:</strong> {{ selectedFine.resident_name }}</p>
                <p><strong>Casa:</strong> {{ selectedFine.address }}</p>
                <p><strong>Teléfono:</strong> {{ selectedFine.phone }}</p>
                <p><strong>Email:</strong> {{ selectedFine.email }}</p>
              </div>
            </v-flex>
            <v-flex xs12 md6>
              <div class="mb-4">
                <h3 class="primary--text mb-3">Multa</h3>
                <p><strong>Monto:</strong> ${{ selectedFine.fine_amount }}</p>
                <p><strong>Estado:</strong>
                  <v-chip
                      :color="getFineStatusColor(selectedFine.status)"
                      text-color="white"
                      small
                  >
                    {{ selectedFine.status }}
                  </v-chip>
                </p>
                <p><strong>Fecha de Notificación:</strong> {{ selectedFine.notification_date || 'No enviada' }}</p>
              </div>
            </v-flex>
            <v-flex xs12>
              <div class="mb-4">
                <h3 class="primary--text mb-3">Imagen del Vehículo</h3>
                <v-img
                    :src="selectedFine.vehicle_image"
                    max-height="300"
                    class="rounded"
                ></v-img>
              </div>
            </v-flex>
            <v-flex xs12>
              <div class="mb-4">
                <h3 class="primary--text mb-3">Observaciones</h3>
                <p>{{ selectedFine.observations }}</p>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn
              v-if="selectedFine && selectedFine.status === 'Pendiente'"
              color="success"
              @click="showSendDialog = true"
          >
            Enviar Multa
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogFineDetail = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showSendDialog" max-width="500">
      <v-card class="elevation-5">
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            Enviar Multa
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
              class="align-self-end"
              color="red"
              icon
              @click="showSendDialog = false"
          ><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pt-4">
          <p class="mb-4">Seleccione el método para enviar la multa:</p>
          <v-layout row wrap>
            <v-flex xs12>
              <v-btn
                  block
                  color="primary"
                  class="mb-2"
                  :loading="sendingFine"
                  @click="sendFine('email')"
              >
                <v-icon class="mr-2">mdi-email-outline</v-icon>
                Enviar por Correo Electrónico
              </v-btn>
            </v-flex>
            <v-flex xs12>
              <v-btn
                  block
                  color="primary"
                  :loading="sendingFine"
                  @click="sendFine('sms')"
              >
                <v-icon class="mr-2">mdi-message-text-outline</v-icon>
                Enviar por SMS
              </v-btn>
            </v-flex>
            <v-flex xs12>
              <v-btn
                  block
                  color="primary"
                  class="mt-2"
                  text
                  @click="showSendDialog = false"
              >
                Cancelar
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <h2 class="subheading grey--text">Multas por Exceso de Velocidad</h2>

    <v-layout row wrap class="mt-4 mb-4">
      <v-flex xs12 md3>
        <v-card outlined>
          <v-card-text class="text-center">
            <p class="mb-2 caption">Multas Detectadas</p>
            <p class="display-2 primary--text">{{ totalFines }}</p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md3>
        <v-card outlined>
          <v-card-text class="text-center">
            <p class="mb-2 caption">Multas Pendientes</p>
            <p class="display-2 orange--text">{{ pendingFines }}</p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md3>
        <v-card outlined>
          <v-card-text class="text-center">
            <p class="mb-2 caption">Multas Enviadas</p>
            <p class="display-2 blue--text">{{ sentFines }}</p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md3>
        <v-card outlined>
          <v-card-text class="text-center">
            <p class="mb-2 caption">Ingresos Totales</p>
            <p class="display-2 green--text">${{ totalRevenue }}</p>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-card class="elevation-0 mt-4">
      <v-card-title>
        Registro de Multas
        <v-spacer></v-spacer>
        <v-btn icon color="primary" :loading="loading" @click="fetchFines">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap class="mb-3">
          <v-flex xs12 sm4>
            <v-text-field
                v-model="filter"
                prepend-icon="mdi-magnify"
                label="Buscar por placa o residente"
                clearable
                outlined
                dense
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-select
                v-model="statusFilter"
                :items="['Todas', 'Pendiente', 'Enviada', 'Pagada']"
                label="Estado"
                outlined
                dense
            ></v-select>
          </v-flex>
          <v-flex xs12 sm4>
            <v-select
                v-model="speedFilter"
                :items="['Todas', 'Leve (1-10 km/h)', 'Moderada (11-20 km/h)', 'Grave (21-30 km/h)', 'Muy Grave (30+ km/h)']"
                label="Gravedad"
                outlined
                dense
            ></v-select>
          </v-flex>
        </v-layout>

        <v-data-table
            :headers="headers"
            :items="filteredData"
            :search="filter"
            :loading="loading"
            loading-text="Cargando multas de velocidad..."
            class="elevation-1"
            no-data-text="No hay multas registradas"
        >
          <template v-slot:item.speed_excess="{ item }">
            <v-chip
                :color="getSpeedSeverityColor(item.speed_detected - item.speed_limit)"
                text-color="white"
                small
            >
              +{{ item.speed_detected - item.speed_limit }} km/h
            </v-chip>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
                :color="getFineStatusColor(item.status)"
                text-color="white"
                small
            >
              {{ item.status }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
                small
                class="mr-2"
                color="primary"
                @click="openDetail(item)"
            >
              mdi-eye
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-card class="elevation-0 mt-4">
      <v-card-title>
        Análisis de Velocidades
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-card outlined>
              <v-card-title class="primary--text">Top 5 Infracciones</v-card-title>
              <v-card-text>
                <div v-for="(item, index) in topSpeeding" :key="index" class="mb-3">
                  <div class="d-flex justify-space-between align-center">
                    <span><strong>{{ item.plate }}</strong> - {{ item.resident_name }}</span>
                    <v-chip color="red" text-color="white" small>{{ item.speed_detected }} km/h</v-chip>
                  </div>
                  <v-progress-linear
                      :value="(item.speed_detected / 100) * 100"
                      color="red"
                      class="mt-1"
                  ></v-progress-linear>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 md6>
            <v-card outlined>
              <v-card-title class="primary--text">Distribución por Gravedad</v-card-title>
              <v-card-text>
                <div class="mb-3">
                  <div class="d-flex justify-space-between">
                    <span>Leve (1-10 km/h)</span>
                    <v-chip color="yellow" text-color="white" small>{{ severityStats.light }}</v-chip>
                  </div>
                  <v-progress-linear :value="totalFines ? (severityStats.light / totalFines) * 100 : 0" color="yellow" class="mt-1"></v-progress-linear>
                </div>
                <div class="mb-3">
                  <div class="d-flex justify-space-between">
                    <span>Moderada (11-20 km/h)</span>
                    <v-chip color="orange" text-color="white" small>{{ severityStats.moderate }}</v-chip>
                  </div>
                  <v-progress-linear :value="totalFines ? (severityStats.moderate / totalFines) * 100 : 0" color="orange" class="mt-1"></v-progress-linear>
                </div>
                <div class="mb-3">
                  <div class="d-flex justify-space-between">
                    <span>Grave (21-30 km/h)</span>
                    <v-chip color="red" text-color="white" small>{{ severityStats.serious }}</v-chip>
                  </div>
                  <v-progress-linear :value="totalFines ? (severityStats.serious / totalFines) * 100 : 0" color="red" class="mt-1"></v-progress-linear>
                </div>
                <div>
                  <div class="d-flex justify-space-between">
                    <span>Muy Grave (30+ km/h)</span>
                    <v-chip color="deep-red" text-color="white" small>{{ severityStats.verySevere }}</v-chip>
                  </div>
                  <v-progress-linear :value="totalFines ? (severityStats.verySevere / totalFines) * 100 : 0" color="deep-red" class="mt-1"></v-progress-linear>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import speedMonitorService from '@/services/speedMonitorService'

export default {
  name: 'SpeedingFines',
  data () {
    return {
      loading: false,
      sendingFine: false,
      dialogFineDetail: false,
      showSendDialog: false,
      selectedFine: null,
      filter: '',
      statusFilter: 'Todas',
      speedFilter: 'Todas',
      headers: [
        { text: 'Placa', value: 'plate', sortable: true },
        { text: 'Residente', value: 'resident_name', sortable: true },
        { text: 'Velocidad', value: 'speed_detected', sortable: true },
        { text: 'Exceso', value: 'speed_excess', sortable: false },
        { text: 'Fecha', value: 'detection_date', sortable: true },
        { text: 'Monto', value: 'fine_amount', sortable: false },
        { text: 'Estado', value: 'status', sortable: true },
        { text: 'Acciones', value: 'actions', sortable: false }
      ],
      /*
      mockFines: [
        {
          id: 1,
          plate: 'ABC-1234',
          resident_name: 'Carlos López',
          address: 'Calle Central 123',
          phone: '555-0101',
          email: 'carlos.lopez@email.com',
          vehicle_model: 'Toyota Corolla',
          vehicle_color: 'Gris',
          vehicle_year: '2020',
          speed_detected: 65,
          speed_limit: 40,
          detection_datetime: '2026-08-29 14:30:00',
          detection_date: '2026-08-29',
          fine_amount: 500,
          status: 'Pendiente',
          notification_date: null,
          vehicle_image: 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22300%22 height=%22200%22%3E%3Crect width=%22300%22 height=%22200%22 fill=%22%23ddd%22/%3E%3Ctext x=%22150%22 y=%22100%22 text-anchor=%22middle%22 font-size=%2220%22 fill=%22%23666%22%3EToyota Corolla Gris%3C/text%3E%3C/svg%3E',
          observations: 'Conducción detectada en Calle Principal. Exceso de 25 km/h sobre el límite permitido.'
        },
        {
          id: 2,
          plate: 'XYZ-5678',
          resident_name: 'Ana Rodríguez',
          address: 'Avenida Principal 456',
          phone: '555-0102',
          email: 'ana.rodriguez@email.com',
          vehicle_model: 'Honda Civic',
          vehicle_color: 'Azul',
          vehicle_year: '2019',
          speed_detected: 58,
          speed_limit: 40,
          detection_datetime: '2026-08-29 10:15:00',
          detection_date: '2026-08-29',
          fine_amount: 350,
          status: 'Enviada',
          notification_date: '2026-08-29',
          vehicle_image: 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22300%22 height=%22200%22%3E%3Crect width=%22300%22 height=%22200%22 fill=%22%23ddd%22/%3E%3Ctext x=%22150%22 y=%22100%22 text-anchor=%22middle%22 font-size=%2220%22 fill=%22%23666%22%3EHonda Civic Azul%3C/text%3E%3C/svg%3E',
          observations: 'Múltiples incidentes en la zona. Conductor en área residencial.'
        },
        {
          id: 3,
          plate: 'DEF-9101',
          resident_name: 'Roberto García',
          address: 'Calle Secundaria 789',
          phone: '555-0103',
          email: 'roberto.garcia@email.com',
          vehicle_model: 'Ford Focus',
          vehicle_color: 'Negro',
          vehicle_year: '2021',
          speed_detected: 72,
          speed_limit: 40,
          detection_datetime: '2026-08-28 16:45:00',
          detection_date: '2026-08-28',
          fine_amount: 750,
          status: 'Pagada',
          notification_date: '2026-08-28',
          vehicle_image: 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22300%22 height=%22200%22%3E%3Crect width=%22300%22 height=%22200%22 fill=%22%23ddd%22/%3E%3Ctext x=%22150%22 y=%22100%22 text-anchor=%22middle%22 font-size=%2220%22 fill=%22%23666%22%3EFord Focus Negro%3C/text%3E%3C/svg%3E',
          observations: 'Infracción grave. Exceso de 32 km/h. Multa pagada el 2026-08-29.'
        },
        {
          id: 4,
          plate: 'GHI-2345',
          resident_name: 'Laura Fernández',
          address: 'Calle del Parque 321',
          phone: '555-0104',
          email: 'laura.fernandez@email.com',
          vehicle_model: 'Volkswagen Jetta',
          vehicle_color: 'Blanco',
          vehicle_year: '2018',
          speed_detected: 52,
          speed_limit: 40,
          detection_datetime: '2026-08-27 09:20:00',
          detection_date: '2026-08-27',
          fine_amount: 300,
          status: 'Pendiente',
          notification_date: null,
          vehicle_image: 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22300%22 height=%22200%22%3E%3Crect width=%22300%22 height=%22200%22 fill=%22%23ddd%22/%3E%3Ctext x=%22150%22 y=%22100%22 text-anchor=%22middle%22 font-size=%2220%22 fill=%22%23666%22%3EVolkswagen Jetta Blanco%3C/text%3E%3C/svg%3E',
          observations: 'Primera infracción del residente. Leve exceso de velocidad.'
        },
        {
          id: 5,
          plate: 'JKL-6789',
          resident_name: 'Miguel Torres',
          address: 'Avenida del Golf 654',
          phone: '555-0105',
          email: 'miguel.torres@email.com',
          vehicle_model: 'Mazda 3',
          vehicle_color: 'Rojo',
          vehicle_year: '2022',
          speed_detected: 68,
          speed_limit: 40,
          detection_datetime: '2026-08-26 13:50:00',
          detection_date: '2026-08-26',
          fine_amount: 600,
          status: 'Enviada',
          notification_date: '2026-08-26',
          vehicle_image: 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22300%22 height=%22200%22%3E%3Crect width=%22300%22 height=%22200%22 fill=%22%23ddd%22/%3E%3Ctext x=%22150%22 y=%22100%22 text-anchor=%22middle%22 font-size=%2220%22 fill=%22%23666%22%3EMazda 3 Rojo%3C/text%3E%3C/svg%3E',
          observations: 'Segundo incidente del residente en este mes. Exceso de 28 km/h.'
        },
        {
          id: 6,
          plate: 'MNO-1112',
          resident_name: 'Patricia Sánchez',
          address: 'Calle de los Sueños 987',
          phone: '555-0106',
          email: 'patricia.sanchez@email.com',
          vehicle_model: 'Chevrolet Spark',
          vehicle_color: 'Plateado',
          vehicle_year: '2017',
          speed_detected: 55,
          speed_limit: 40,
          detection_datetime: '2026-08-25 11:30:00',
          detection_date: '2026-08-25',
          fine_amount: 350,
          status: 'Pendiente',
          notification_date: null,
          vehicle_image: 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22300%22 height=%22200%22%3E%3Crect width=%22300%22 height=%22200%22 fill=%22%23ddd%22/%3E%3Ctext x=%22150%22 y=%22100%22 text-anchor=%22middle%22 font-size=%2220%22 fill=%22%23666%22%3EChevrolet Spark Plateado%3C/text%3E%3C/svg%3E',
          observations: 'Infracción en zona escolar. Moderada velocidad excedida.'
        }
      ],
      */
      fines: []
    }
  },
  async mounted () {
    await this.fetchFines()
  },
  computed: {
    filteredData () {
      let filtered = this.fines
      if (this.statusFilter !== 'Todas') {
        filtered = filtered.filter(f => f.status === this.statusFilter)
      }
      if (this.speedFilter !== 'Todas') {
        filtered = filtered.filter(f => {
          const excess = (f.speed_detected || 0) - (f.speed_limit || 0)
          if (this.speedFilter === 'Leve (1-10 km/h)') return excess >= 1 && excess <= 10
          if (this.speedFilter === 'Moderada (11-20 km/h)') return excess >= 11 && excess <= 20
          if (this.speedFilter === 'Grave (21-30 km/h)') return excess >= 21 && excess <= 30
          if (this.speedFilter === 'Muy Grave (30+ km/h)') return excess > 30
          return true
        })
      }
      return filtered
    },
    totalFines () {
      return this.fines.length
    },
    pendingFines () {
      return this.fines.filter(f => f.status === 'Pendiente').length
    },
    sentFines () {
      return this.fines.filter(f => f.status === 'Enviada').length
    },
    totalRevenue () {
      return this.fines.filter(f => f.status === 'Pagada').reduce((total, f) => total + (Number(f.fine_amount) || 0), 0)
    },
    topSpeeding () {
      return this.fines.slice().sort((a, b) => (b.speed_detected || 0) - (a.speed_detected || 0)).slice(0, 5)
    },
    severityStats () {
      let light = 0; let moderate = 0; let serious = 0; let verySevere = 0
      this.fines.forEach(f => {
        const excess = (f.speed_detected || 0) - (f.speed_limit || 0)
        if (excess >= 1 && excess <= 10) light++
        else if (excess >= 11 && excess <= 20) moderate++
        else if (excess >= 21 && excess <= 30) serious++
        else if (excess > 30) verySevere++
      })
      return { light, moderate, serious, verySevere }
    }
  },
  methods: {
    async fetchFines () {
      this.loading = true
      try {
        const data = await speedMonitorService.getSpeedingFines()
        this.fines = Array.isArray(data) ? data : (data.results || [])
      } catch (error) {
        console.error('Error al obtener multas de velocidad:', error)
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', 'Error al cargar las multas de velocidad desde el servidor')
        this.$store.commit('snackbar_change_color', 'error')
      } finally {
        this.loading = false
      }
    },
    getFineStatusColor (status) {
      const colors = {
        'Pendiente': 'orange',
        'Enviada': 'blue',
        'Pagada': 'green'
      }
      return colors[status] || 'gray'
    },
    getSpeedSeverityColor (excess) {
      if (excess <= 10) return 'yellow'
      if (excess <= 20) return 'orange'
      if (excess <= 30) return 'red'
      return 'deep-red'
    },
    openDetail (fine) {
      this.selectedFine = JSON.parse(JSON.stringify(fine))
      this.dialogFineDetail = true
    },
    async sendFine (method) {
      if (!this.selectedFine) return
      this.sendingFine = true
      try {
        const updatedFine = await speedMonitorService.sendFine(this.selectedFine.id, method)
        this.selectedFine.status = 'Enviada'
        this.selectedFine.notification_date = (updatedFine && updatedFine.notification_date) ? updatedFine.notification_date : new Date().toISOString().split('T')[0]
        const fineIndex = this.fines.findIndex(f => f.id === this.selectedFine.id)
        if (fineIndex !== -1) {
          this.$set(this.fines, fineIndex, { ...this.selectedFine, ...updatedFine })
        }
        this.showSendDialog = false
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', `Multa enviada por ${method === 'email' ? 'correo electrónico' : 'SMS'} a ${this.selectedFine.resident_name || 'el residente'}`)
        this.$store.commit('snackbar_change_color', 'success')
      } catch (error) {
        console.error('Error al enviar la multa:', error)
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', 'No se pudo enviar la multa al residente')
        this.$store.commit('snackbar_change_color', 'error')
      } finally {
        this.sendingFine = false
      }
    }
  }
}
</script>

<style scoped>
.d-flex {
  display: flex;
}

.justify-space-between {
  justify-content: space-between;
}

.align-center {
  align-items: center;
}

.rounded {
  border-radius: 8px;
}
</style>
